import { useDispatch, useSelector } from "react-redux";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";
import InputAHSF from "../../../Components/InputAHSF";
import { useEffect, useState } from "react";
import {
  GetAttachmentsAnswer,
  UpdateAttachmentsAnswer,
} from "../../../Redux/Reducers/Submitter/AttachmentsAnswer";
import { useParams } from "react-router-dom";

const Attachments = (props) => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.languageReducer.Language);
  const { ApplicationInformationId } = useParams();
  const attachmentsAnswer = useSelector(
    (state) => state.AttachmentsAnswer.AttachmentsAnswer
  );

  const AttachmentsAnswerList = useSelector(
    (state) => state.AttachmentsAnswer.ValidationAttachments
  );

  var AttachmentsAnswerListResult =
    AttachmentsAnswerList?.length > 0
      ? AttachmentsAnswerList[0].list.map((x) => x.code)
      : null;

  console.log(AttachmentsAnswerListResult, "attachment");

  useEffect(() => {
    dispatch(
      GetAttachmentsAnswer({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") ||
          ApplicationInformationId,
      })
    );
  }, [ApplicationInformationId]);

  console.log(attachmentsAnswer, "dddddddd");

  const AddedAttachment = (
    file,
    attachmentsId,
    attachmentsAnswerId,
    attachmentsUrl
  ) => {
    const formData = new FormData();
    formData.append("attachmentsAnswerId", attachmentsAnswerId);
    formData.append("attachmentsId", attachmentsId);
    formData.append("attachmentsUrl", attachmentsUrl || "");
    formData.append(
      "applicationInformationId",
      localStorage.getItem("ApplicationInformationId") ||
        ApplicationInformationId
    );
    formData.append("file", file);

    dispatch(UpdateAttachmentsAnswer(formData));
  };

  return (
    <div className="form-grid" style={{ marginTop:"8px", marginBottom:"7px" }}>
      {attachmentsAnswer?.map((attachment) => (
        <div key={attachment.attachmentsAnswerId}>
          <AttachmentASFH
            // hidelable={true}
            font={"en"}
            show={true}
            disabled={props.disabled}
            clear={false}
            readOnly={false}
            fieldsName={attachment.attachmentsCode}
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                AddedAttachment(
                  file,
                  attachment.attachmentsId,
                  attachment.attachmentsAnswerId,
                  attachment.attachmentsUrl
                );
              }
            }}
            AttachementType="AttachmentsUrl"
            id={attachment.attachmentsId}
            lang={lang}
            singleFile={attachment.attachmentsUrl}
            showValidationMessage={
              AttachmentsAnswerListResult &&
              AttachmentsAnswerListResult.includes(attachment.attachmentsCode)
            }
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
      ))}
    </div>
  );
};

export default Attachments;
